import { useQuery } from '@tanstack/react-query'

export const useBatteryData = () => {
  return useQuery({
    queryKey: ['batteryConfig'],
    queryFn: async () => {
      const response = await fetch('/batConfig')
      if (!response.ok) {
        throw new Error('Failed to fetch battery configuration data')
      }
      return response.json()
    },
  })
}

export const processBatteryData = (batteryData) => {
  if (!batteryData) return {}
  
  const dropdownTypes = {}
    // Process the JSON data to categorize by type and brand
  Object.entries(batteryData).forEach(([_key, value]) => {
    const { type, brand } = value
    
    if (!dropdownTypes[type]) {
      dropdownTypes[type] = {}
    }
    if (!dropdownTypes[type][brand]) {
      dropdownTypes[type][brand] = {
        models: [],
      }
    }
    dropdownTypes[type][brand].models.push(value['model'])
  })

  return { dropdownTypes, batteryData }
}

export const sortOptions = (options) => {
  return options.sort((a, b) => {
    if (a === 'Standard') return -1
    if (b === 'Standard') return 1
    if (a === 'Other') return 1
    if (b === 'Other') return -1
    return a.localeCompare(b)
  })
}
